import React from "react";


export interface CsrfContextStorage {
    csrfToken: string;
}

export const CsrfContext = React.createContext<CsrfContextStorage>({csrfToken: ""});
